/* eslint-disable no-underscore-dangle */

import CardSkin1 from '@/components/space/card-skin1.js';

export default function ByTags({ spaces }) {
  let newSpaces = spaces;
  if (!newSpaces) newSpaces = [];
  return (
    <div className="relative grid w-full grid-cols-1 pb-16 md:grid-cols-3 lg:grid-cols-4 gap-y-10 md:gap-x-5 md:gap-y-7">
      <div className="w-full rounded-lg lg:h-[330px] relative">
        <CardSkin1
          item={newSpaces[0]}
          options={{
            imageProps: {
              space: true,
            },
          }}
        />
      </div>
      <div className="w-full rounded-lg h-[330px] relative">
        <CardSkin1
          item={newSpaces[1]}
          options={{
            imageProps: {
              space: true,
            },
          }}
        />
      </div>
      <div className="w-full rounded-lg h-[330px] relative">
        <CardSkin1
          item={newSpaces[2]}
          options={{
            imageProps: {
              space: true,
            },
          }}
        />
      </div>
      <div className="w-full rounded-lg h-[330px] relative">
        <CardSkin1
          item={newSpaces[3]}
          options={{
            imageProps: {
              space: true,
            },
          }}
        />
      </div>
      <div className="w-full rounded-lg h-[330px] relative">
        <CardSkin1
          item={newSpaces[4]}
          options={{
            imageProps: {
              space: true,
            },
          }}
        />
      </div>
      <div className="w-full rounded-lg h-[330px] relative">
        <CardSkin1
          item={newSpaces[5]}
          options={{
            imageProps: {
              space: true,
            },
          }}
        />
      </div>
      <div className="w-full rounded-lg h-[330px] relative">
        <CardSkin1
          item={newSpaces[6]}
          options={{
            imageProps: {
              space: true,
            },
          }}
        />
      </div>
      <div className="w-full rounded-lg h-[330px] relative">
        <CardSkin1
          item={newSpaces[7]}
          options={{
            imageProps: {
              space: true,
            },
          }}
        />
      </div>
    </div>

  );
}
